import { Component, Vue } from 'vue-property-decorator'

@Component
export class ModalHandler extends Vue {
  mounted() {
    this.$onOpen()
  }

  destroyed() {
    this.$onClose()
  }

  $onOpen() {
    document.body.className += ' no-scroll'
  }

  $onClose() {
    document.body.className = document.body.className.replace(/no-scroll/g, '')
  }
}
